export const SET_NAVIGATION_LOCK = 'SET_NAVIGATION_LOCK';
export const CLEAR_NAVIGATION_LOCK = 'CLEAR_NAVIGATION_LOCK';
